<style scoped>
    @import url("../../../styles/smartControl/grafHist.scss");
</style>

<template>
    <!--'width':novaLargura-->
    <div class="box_grafHist"
    :style="{'min-height':novaAltura}"
    >
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="boxTitGraf" v-if="!flagLoading">

            <!-- ICONES DE CONTROLE DO GRAFICO -->
            <div class="box_icons" v-if="!flagLoading">

                <v-tooltip 
                text="Você pode adicionar novos gáficos para comparação e remove-lo de forma individual através do botão (x)." 
                location="top"
                class="refreshGraf"
                >
                    <template v-slot:activator="{ props }">
                        <v-icon 
                        v-bind="props" 
                        size="20"
                        @mouseover="backColorHelp = '#EA9611'"
                        @mouseleave="backColorHelp = ''"
                        :style="{'color':backColorHelp}"
                        >
                            mdi-help-circle-outline
                        </v-icon>
                    </template>
                </v-tooltip>

            </div>

            <span class="titGraf">{{ main_tit }}</span>
            <!-- <v-icon v-if="!flagBTN">mdi-image-refresh-outline</v-icon> -->

            <!-- ICONES DE CONTROLE DO GRAFICO-->
            <div class="box_icons" v-if="!flagLoading">

                <v-icon 
                @click="plot()" 
                class="refreshGraf"
                @mouseover="backColorRefresh = '#EA9611'"
                @mouseleave="backColorRefresh = ''"
                :style="{'color':backColorRefresh}"
                >
                    mdi-refresh-circle
                </v-icon>

            </div>

            <!-- ICONES DE CONTROLE DO GRAFICO-->
            <div class="box_icons" v-if="!flagLoading">

                <v-icon 
                @click="plotClose()" 
                class="refreshGraf"
                @mouseover="backColorX = '#EA9611'"
                @mouseleave="backColorX = 'red'"
                :style="{'color':backColorX}"
                >
                    mdi-close-octagon
                </v-icon>

            </div>
        </div>

        <!--  -->
        <div class="semDadosGraf" v-if="!flagApex && !flagLoading">
            <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
            <div>AINDA NÃO HÁ DADOS</div>
        </div>

        <!--  v-if="!flagBTN && !flagLoading && flagApex" -->
        <apexchart v-if="!flagLoading && flagApex" 
        class="ajusteApexGraf" 
        :key="chartKey" 
        ref="chartA" 
        :series="series" 
        :options="options"
        :height="alturaGrafico"
        ></apexchart>
        
    </div>
</template>

<script>
import axios from 'axios'
import { convFromUtc } from "../auxSC/timeConv.js"; // criado em 04/05/2026
import { bus } from "../auxSC/eventBus"; // 14/06/2026

export default {

    props:['range_init','range_end','device_id','target_key','main_tit','indexGraf','fatherCounter'],

    data() {
        return {
            liExib:[], // value
            labelsDatas:[], // date

            liExibSUB:[], // value --> listas associadas a lista principal.
            labelsDatasSUB:[], // date

            flagLoading:true, // init loading...
            flagBTN:true,
            backColorRefresh:'',
            backColorHelp:'',
            backColorX:'red',

            // controle de tamanho da pagina
            novaLargura:'250px',
            novaAltura:'150px',
            alturaGrafico:'150px',

            flagApex:true, // inicia ok
            chartKey: 0, // chave de atualização apex chart
            series: [
                {
                    name: 'Entrada',
                    type: 'column',
                    //data: [18, 20, 22, 20, 16, 15],
                    data: [0, 0, 0, 2, 0, 4]
                },
                /*{
                    name: 'Sensor associado',
                    type: 'line',
                    data: [0, 0, 0, 0, 0, 0],
                    dashArray: 5  // Define a linha como pontilhada
                }*/
            ],
            options:{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false  // Desativa o menu (toolbar)
                    },
                    //width: '280px' // Pode ser um valor em pixels (px) ou percentual (%)
                },
                stroke: {
                    //width: 1.5, // grossura da linha (para o caso sem sensor associado)
                    width: [0, 5], // intervalo de grossura da coluna (bom resultado)
                    //dashArray: 5 // 1(graf 1 pontilhado) | 2(graf 2 pontilhado) | 3(pontilhado grosso nos 2 graf) | 4
                    //dashArray: [0, 2]  // Faz a segunda série (linha) ser pontilhada
                },
                //stroke: {width:2, dashArray:0},
                //labels: ['', '', '', '', '', ''],
                yaxis: { 
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                },
                xaxis: {
                    //categories: this.labelsDatas, // inicia vazio?
                    //type: 'datetime',
                    type: 'category',
                    categories: this.labelsDatas,
                    labels: { show: false },
                    /*axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }*/
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value.toFixed(2); // Limita a 2 casas decimais
                        }
                    },
                    x: {
                        //format: 'dd/MM/yyyy HH:mm' // se forem datas
                        format: 'dd/MM/yyyy' // ou 'dd MMM yyyy', etc.
                    },
                },
            },
        }
    },

    methods:{

        dtToStr(dt) {

            const dd = String(dt.getUTCDate()).padStart(2, '0')
            const mm = String(dt.getUTCMonth() + 1).padStart(2, '0')
            const yyyy = dt.getUTCFullYear()

            const hh = String(dt.getUTCHours()).padStart(2, '0')
            const min = String(dt.getUTCMinutes()).padStart(2, '0')

            return `${dd}/${mm}/${yyyy}-${hh}:${min}`
        },

        plotClose() {
            //console.log('[GrafHist][plotClose] start') 
            //console.log('[GrafHist][plotClose] indexGraf: ',this.indexGraf) // rcv via props
            this.$emit('closeGraf',this.indexGraf)
        },

        async plot() {

            //console.log('[GrafHist][plot] start')

            this.flagLoading = true

            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }
            
            // -- intervalor pre-definido: agora - 48h
            //const dtNow = new Date() // agora UTC
            //const dt72h = new Date(dtNow.getTime() - (72 * 60 * 60 * 1000)) // 48h atrás

            let params = { 
                'cliente':this.$store.state.emailCliente, 
                'sistema':this.$store.state.sistemaSC, 
                'range_init':this.range_init, // '30/05/2026-04:00' <-- (+antigo)
                'range_end':this.range_end, // '02/06/2026-18:00' <-- (+recente)
                'device_id':this.device_id
            }
            //console.log('[GrafHist][plot] params: ',params)

            const url = this.$store.state.pathAxiosBASE + '/xhistirrig'

            let histRangeRcv = []
            const res = await axios.post(url, params, {headers})
            //console.log('res: ',res.data.result)

            if (res.data.result.ok) { 
                histRangeRcv = res.data.result.hist 
            } 
            else { 

                this.flagApex = false // não exibir o gráfico (mensagem de erro)
                this.flagLoading = false
            }

            if (histRangeRcv.length == 0) {

                this.flagApex = false // não exibir o gráfico (mensagem de erro)
                this.flagLoading = false
                console.log('[GrafHist][plot] lista vazia')
                return
            }

            let histRange = []
            let histDT = []
            let dtUtcIso = null
            let resConvDT = null
            let target_value = null
            let c = 0
            while (c < histRangeRcv.length) {
                
                target_value = histRangeRcv[c]['rcv_content'][this.target_key]
                histRange.push(target_value)

                dtUtcIso = histRangeRcv[c]['received_at']
                resConvDT = convFromUtc(dtUtcIso, tzName)
                histDT.push(`${resConvDT.dataStr}-${resConvDT.hhmm}`)

                c++
            }

            this.series = [
                {
                    name: this.main_tit,
                    type: 'column',
                    data: histRange
                }
            ]

            this.options.colors = ['#008FFB']
            this.options.stroke.width = 2 // -- grossura da linha
            this.options.chart.type = 'bar'
            this.options.dataLabels = { enabled: false }
            this.options.markers = { size: [0] }
            this.options.xaxis.categories = histDT

            this.chartKey++ // força redraw

            this.flagLoading = false
            this.flagApex = true // abrir graf

            this.pageTam()
        },

        pageTam() {

            // -- função chamada pelo BUS dinamicamente, para atualizar o tamanho da exibição do gráfico.

            let widthExibPerc = this.$store.state.widthDinamCA // percentual da exibição | string
            widthExibPerc = parseFloat(widthExibPerc.replace('%', ''))
            const largura = window.innerWidth
            //console.log('[GrafHist][pageTam] window.innerWidth (largura): ',largura)

            if (largura > 450) {
                const novaLargura = 0.8*largura // aux calc
                this.novaAltura = `${0.4*novaLargura}px` // proporção arbitrária (exibição horizontal)
                this.novaLargura = `${novaLargura*(widthExibPerc/100)}px`
                this.alturaGrafico = Math.round( 0.4 * novaLargura * (widthExibPerc/100) )
            }
            else {
                this.novaLargura = `280px`; this.alturaGrafico = `220px`;
            }
            
            //this.chartKey++
        }
    },

    mounted() {
        this.refreshHandler = () => this.pageTam()
        bus.on('refresh-graf', this.refreshHandler)
    },

    beforeUnmount() {
        // -- necessário para evitar multiplos escutadores
        bus.off('refresh-graf', this.refreshHandler)
    },

    created() {

        this.chartKey = this.fatherCounter // rcv via props
        //console.log('[GrafHist][created] chartKey: ',this.chartKey)

        this.pageTam()
        this.plot()
        this.pageTam() // store com tamanho dinamico ao pressionar o btn menu lateral ?? 02/06/2026
    }
}
</script>
